import ReactCountUp from 'react-countup'

import styled from 'styled-components'

import { convertHexToRGBA } from 'core/helpers'

import { TBoxIntroStyle } from './types'

export const CardIntro = styled.div<TBoxIntroStyle>`
  position: fixed;
  height: 40%;
  width: 100%;
  background-image: ${p =>
    `linear-gradient( 178.1deg,  ${p.background} 100%, ${convertHexToRGBA({
      hex: p.background,
      opacity: 8,
    })} 100% );`};
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  border-radius: 0px 0px 10px 10px;
`

export const CardMenu = styled.div`
  position: fixed;
  height: 60%;
  width: calc(100% - 40px);
  background: ${p => p.theme.colors.light};
  margin: 0 20px;
  z-index: 10;
  bottom: 0;
  border-radius: 7px 7px 0 0;
  overflow: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  border-radius: 15px 15px 0px 0px;

  ::-webkit-scrollbar {
    width: 0;
  }
`

export const Score = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 80px;
  color: ${p => p.theme.colors.foreground};
`

export const CountUpEmpty = styled.h1`
  font-size: 3.8rem;
  font-family: ${p => p.theme.fonts.tertiary};

  @media only screen and (min-width: 321px) {
    font-size: 5.5rem;
  }
`

export const CountUp = styled(ReactCountUp)`
  font-size: 3.8rem;
  font-family: ${p => p.theme.fonts.tertiary};

  @media only screen and (min-width: 321px) {
    font-size: 5.5rem;
  }
`

export const ScoreLabel = styled.span`
  font-size: 0.8rem;
  font-weight: 400;
  margin-top: 2px;

  @media only screen and (min-width: 321px) {
    font-size: 0.9rem;
    margin-top: -5px;
  }
`
export const WrapperIntentActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`

export const ButtonIntentAction = styled.button<{
  color: string
  backgroundColor: string
}>`
  appearance: none;
  background-color: ${p => p.backgroundColor};
  border: none;
  border-radius: 6px;
  box-sizing: border-box;
  color: ${p => p.color};
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, 'Segoe UI', Helvetica, Arial,
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 6px 16px;
  position: relative;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
`
